import React from "react";

import loaderGif from "./loader.gif";

import { ReactComponent as DashboardIcon } from "./dashboard-icon.svg";
import { ReactComponent as DirectSendIcon } from "./direct-send-icon.svg";
import { ReactComponent as CardIssuingIcon } from "./card-issuing-icon.svg";
import { ReactComponent as ApiIcon } from "./api-icon.svg";
import { ReactComponent as LocationsIcon } from "./locations-icon.svg";
import { ReactComponent as SettingsIcon } from "./settings-icon.svg";
import { ReactComponent as HelpIcon } from "./help-icon.svg";
import { ReactComponent as CheckIcon } from "./check.svg";
import { ReactComponent as EditIcon } from "./edit-icon.svg";
import { ReactComponent as EditLargeIcon } from "./edit-large.svg";
import { ReactComponent as ArrowLeft } from "./arrow-left.svg";
import { ReactComponent as ArrowPaginationLeft } from "./arrow-pagination-left.svg";
import { ReactComponent as ArrowPaginationRight } from "./arrow-pagination-right.svg";
import { ReactComponent as CalendarIcon } from "./calendar-icon.svg";
import { ReactComponent as ArrowBottom } from "./arrow-bottom.svg";
import { ReactComponent as ArrowDownBold } from "./arrow-down-bold.svg";
import { ReactComponent as DownloadIcon } from "./download-icon.svg";
import { ReactComponent as FilterIcon } from "./filter-icon.svg";
import { ReactComponent as SearchIcon } from "./search-icon.svg";
import { ReactComponent as AddIcon } from "./add-icon.svg";
import { ReactComponent as EyeClosed } from "./eye-closed.svg";
import { ReactComponent as EyeOpen } from "./eye-open.svg";
import { ReactComponent as Mail } from "./mail.svg";
import { ReactComponent as UploadIcon } from "./upload-icon.svg";
import { ReactComponent as ConfirmMessageIcon } from './success-message-icon.svg';
import { ReactComponent as ErrorMessageIcon } from './error-message-icon.svg';
import { ReactComponent as CheckMark } from './check-mark.svg';
import { ReactComponent as ExpandIcon } from './expand-icon.svg';
import { ReactComponent as CollapseIcon } from './collapse-icon.svg';
import { ReactComponent as CopyIcon } from './copy-icon.svg';
import { ReactComponent as PendingIcon } from './pending-icon.svg';
import { ReactComponent as InactiveIcon } from './inactive-icon.svg';
import { ReactComponent as CloseIcon } from './close.svg';
import { ReactComponent as LockIcon } from './lock-icon.svg';
import { ReactComponent as LockOpenIcon } from './lock-open-icon.svg';
import { ReactComponent as ReportsIcon } from './reports-icon.svg';
import { ReactComponent as DeleteIcon } from './delete-icon.svg';
import { ReactComponent as InfoIcon } from './info-icon.svg';
import { ReactComponent as ArrowDown } from './arrow-down.svg';
import { ReactComponent as ResendInvite } from './resend-invite.svg';
import { ReactComponent as PrintIcon } from './print-icon.svg';
import { ReactComponent as GiftIcon } from './gift.svg';
const LoadingIcon = () => (
    <img className="loading-icon" src={loaderGif} alt="Loading..."/>
);

export {
    DashboardIcon,
    DirectSendIcon,
    CardIssuingIcon,
    ApiIcon,
    LocationsIcon,
    SettingsIcon,
    HelpIcon,
    CheckIcon,
    EditIcon,
    EditLargeIcon,
    ArrowLeft,
    ArrowPaginationLeft,
    ArrowPaginationRight,
    CalendarIcon,
    ArrowBottom,
    DownloadIcon,
    FilterIcon,
    SearchIcon,
    AddIcon,
    UploadIcon,
    ConfirmMessageIcon,
    ErrorMessageIcon,
    LoadingIcon,
    EyeClosed,
    EyeOpen,
    Mail,
    CheckMark,
    ArrowDown,
    ArrowDownBold,
    ExpandIcon,
    CollapseIcon,
    CopyIcon,
    PendingIcon,
    InactiveIcon,
    CloseIcon,
    LockIcon,
    LockOpenIcon,
    ReportsIcon,
    DeleteIcon,
    InfoIcon,
    ResendInvite,
    PrintIcon,
    GiftIcon
}